import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeatureUsageResponse, UsageResponse } from '../app/models/usage';
import { environment } from '../environments/environment';

/**
 * Kept apart from PartnersService, which is already a grab-bag of partners, tenants, users,
 * shipments and blob downloads.
 */
@Injectable({
  providedIn: 'root'
})
export class UsageService {
  private readonly usageUrl = `${environment.api.baseUrl}${environment.api.endpoints.usage}`;

  constructor(private http: HttpClient) {}

  /**
   * @param refresh rebuild the server-side snapshot instead of serving the cached one. The
   *                snapshot is cached for ten minutes, so this is the only way to see a user
   *                provisioned moments ago.
   */
  getUsage(refresh = false): Observable<UsageResponse> {
    const url = refresh ? `${this.usageUrl}/users?refresh=true` : `${this.usageUrl}/users`;
    return this.http.get<UsageResponse>(url);
  }

  /**
   * What every tenant spent on the metered features in one month.
   *
   * @param period `YYYY-MM`; the current month when omitted. There is no refresh flag — the
   *               counters are read live on every call, because a ten-minute-old spend figure is
   *               the wrong thing to show somebody about to change a limit.
   */
  getFeatureUsage(period?: string): Observable<FeatureUsageResponse> {
    const url = period ? `${this.usageUrl}/features?period=${period}` : `${this.usageUrl}/features`;
    return this.http.get<FeatureUsageResponse>(url);
  }
}
